import config from 'config';

import { FC } from "react";
import { QRCodeCanvas } from "qrcode.react";
// Types
import MediaFormats from 'types/MediaFormats';
// Components
import { Button } from './Buttons';
// i18next
import { useTranslation } from 'react-i18next';
// Utilities
import { downloadQRCode } from 'utilities/utilities';

interface QRCodeProps {
  link: string;
  quizName: string;
  quizNameSlug: string;
  qrCodeLogo?: string;
  qrCodeLogoFormat?: MediaFormats.Logo | MediaFormats.RectLogo;
  showDownloadButton?: boolean;
}
 
const QRCode:FC<QRCodeProps> = ({ link, quizName, quizNameSlug, qrCodeLogo, qrCodeLogoFormat = MediaFormats.Logo , showDownloadButton }) => {
  const { t } = useTranslation();

  const qrCodeLink = link || `${config.quizURL}/quiz/${quizNameSlug}`;

  return (
    <div className="pt-6">
      <QRCodeCanvas
        id="qrcode-canvas"
        level="H"
        size={200}
        value={qrCodeLink}
        imageSettings={{
          src: qrCodeLogo || '',
          height: qrCodeLogoFormat === MediaFormats.RectLogo ? 45 : 60,
          width: qrCodeLogoFormat === MediaFormats.RectLogo ? 90 : 60,
          excavate: true,
          crossOrigin: 'anonymous'
        }}
      />
      {showDownloadButton ? (
        <Button onClick={() => downloadQRCode(quizName)} className="mt-2">{t('buttons.downloadQrCode')}</Button>
      ) : null}
    </div>
  );
}
 
export default QRCode;
